import { Site } from '@envato/foundation-types'

const experimentConfig = {
  globalExperiment: {
    experimentId: 'gKIzsB-zQ_CEXG-jI-AyGQ',
    running: true,
    loadingCover: true,
    sites: [
      Site.themeforest,
      Site.graphicriver,
      Site.codecanyon,
      Site.photodune,
      Site.threedocean,
      Site.videohive,
      Site.audiojungle
    ],
    variantsWeights: [1, 9],
    variants: {
      0: {
        globalExperiment: false
      },
      1: {
        globalExperiment: true
      }
    }
  },
  homepageNewDesignPhase2: {
    experimentId: 'GjGUxbSFRrCPOvQ9sQUSfw',
    running: true,
    loadingCover: true,
    sites: [Site.themeforest],
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        homepageNewDesign: true,
        homepageNewDesignPhase2: false,
        homepageContentHeavy: false
      },
      1: {
        homepageNewDesign: true,
        homepageNewDesignPhase2: true,
        homepageContentHeavy: false
      },
      2: {
        homepageNewDesign: true,
        homepageContentHeavy: true
      }
    }
  },
  categoryPageRapidTest: {
    experimentId: 'StsxY9gOS2KNGFztmIxtuA',
    running: true,
    loadingCover: true,
    sites: [
      Site.audiojungle,
      Site.themeforest,
      Site.videohive,
      Site.codecanyon,
      Site.graphicriver
    ],
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        categoryPageBlocksB: false
      },
      1: {
        categoryPageBlocksB: true
      }
    }
  },
  rapidTestAddToCartColours: {
    experimentId: 'ygcGsJeWRjeNBiLhQb1VQA',
    running: true,
    loadingCover: false,
    sites: [
      Site.audiojungle,
      Site.themeforest,
      Site.videohive,
      Site.codecanyon,
      Site.graphicriver
    ],
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        invertedAddToCartButton: false,
        invertedAddToCartButtonWithPlus: false
      },
      1: {
        invertedAddToCartButton: true,
        invertedAddToCartButtonWithPlus: false
      },
      2: {
        invertedAddToCartButton: false,
        invertedAddToCartButtonWithPlus: true
      }
    }
  },
  homepageImagePerformance: {
    experimentId: 'LPrmT_rJRtqsVVSjqiWPSw',
    running: false,
    loadingCover: true,
    sites: [Site.themeforest],
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        'homepage:lazyload': false,
        'homepage:webpImage': false,
        homepageNewDesign: true,
        homepageContentHeavy: true
      },
      1: {
        'homepage:lazyload': true,
        'homepage:webpImage': true,
        homepageNewDesign: true,
        homepageContentHeavy: true
      }
    }
  }
}

export default experimentConfig
